<template lang="pug">
  Detalle(@prev="prev")
</template>

<script>

import Detalle from '@/components/UI/Detalle'

export default {
  name: 'Paso4',

  components: {
    Detalle
  },

  data: () => ({
  }),

  watch: {
  },

  computed: {
  },

  methods: {
    prev () {
      this.$store.commit('SET_PASO', 3)
      this.$router.push('/paso3')
    }
  }
}

</script>

<style type="text/css">

</style>
